

































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import PtsdMixin from '../PtsdMixin'

export default mixins(AuthorizationMixin, PtsdMixin).extend({
  computed: {
    ...mapGetters('workflow', ['isDone']),
    minDaysUntilP2(): number {
      return Math.max(4, this.daysUntilP1 + 1) // todo: wann darf p2 frühestens beginnen, relativ zu p1?
    },
    minDaysUntilP4(): number {
      return Math.max(4, this.daysUntilP3 + 1) // todo: wann darf p2 frühestens beginnen, relativ zu p1?
    },
  },
  data() {
    return {
      agreedToAntiSuicideContract: false,
      emergencyContact: '',
      daysUntilP1: 2,
      daysUntilP2: 4,
      daysUntilP3: 2,
      daysUntilP4: 4,
      daysUntilP5: 2,
      addresseeOfP5: null,
    }
  },
  watch: {
    daysUntilP1(val: number) {
      this.daysUntilP2 = Math.max(4, val + 2)
    },
    daysUntilP3(val: number) {
      this.daysUntilP4 = Math.max(4, val + 2)
    },
  },
})
